// StaffCostTypeEnum in SubsBuddy.Core/Features/People/Enums/StaffCostTypeEnum.cs.
// 1-based, so that null is unambiguously 'not recorded'.
export const StaffCostTypes = [
  {
    id: 1,
    name: 'SB_CostType_Per_Session'
  },
  {
    id: 2,
    name: 'SB_CostType_Per_Day'
  }
];
